import type { TaskStatusType } from '../types';

/** Backend sends enum values as ints. Fallback map for string values during migration. */
const STATUS_TYPE_MAP: Record<string, TaskStatusType> = {
  Todo: 'todo',
  InProgress: 'in-progress',
  Done: 'done',
};

const INT_TO_STATUS: Record<number, TaskStatusType> = {
  0: 'todo',
  1: 'in-progress',
  2: 'done',
};

/**
 * Converts an API status type (int enum or legacy string) to the UI kebab-case enum.
 * Falls back to 'todo' when the value is unrecognized.
 */
export function statusTypeFromApi(apiType: number | string | null | undefined): TaskStatusType {
  if (apiType == null) return 'todo';
  if (typeof apiType === 'number') {
    return INT_TO_STATUS[apiType] ?? 'todo';
  }
  return STATUS_TYPE_MAP[apiType] ?? 'todo';
}
